function About() {
  return (
    <div className="page-container">
      <h1 className="page-title">about me</h1>
      <div className="body-text">
        hi i'm owen!
      </div>
    </div>
  );
}

export default About;